import { exchangeRates } from '@/constants';
import type { TBeneficiaries, TContactSupport } from '@/types/user.types';
import { consoleError } from '@/utils/common-utils';
import axios from 'axios';

// const apiUrl_old = import.meta.env.VITE_BACKEND_URL_OLD;
const apiUrl_new = import.meta.env.VITE_BACKEND_URL_NEW;

export const httpNoAuth = axios.create({ baseURL: apiUrl_new });

export const ContactSupport = async (payload: TContactSupport): Promise<void> => {
  try {
    await httpNoAuth.post<TContactSupport>('/v1/admin/contact_us', payload);
  } catch (error: any) {
    throw new Error(`HTTP error! ${error.response?.status ?? error.message}`);
  }
};

export const transcripts = async (videoId: string): Promise<any> => {
  try {
    const response = await httpNoAuth.get(`/${videoId}.vtt`, {
      baseURL: 'https://api-v1.yourlifex.com/static/transcripts',
    });
    return response.data;
  } catch (error: any) {
    throw new Error(`HTTP error! ${error.response?.status ?? error.message}`);
  }
};

export const ipdata = async (): Promise<any> => {
  try {
    const response = await axios.get('https://ipapi.co/json');
    return response.data;
  } catch (error: any) {
    consoleError('Failed to get userIP', error);
    return null;
  }
};

export const getBeneficiarieByIDNoAuth = async (ID: string, key: string = 'uid'): Promise<TBeneficiaries> => {
  const payload = {
    [key]: ID,
  };
  try {
    const response = await httpNoAuth.post<TBeneficiaries>(`/v1/beneficiaries`, payload, {
      headers: {
        'Content-Type': 'application/json',
        accept: 'application/json',
      },
    });
    return response.data;
  } catch (error: any) {
    throw new Error(`HTTP error! ${error.response?.status ?? error.message}`);
  }
};

export const showLocalizedPrice = async (ipdata: any, usdAmount: number | bigint) => {
  let price: string;

  const formatCurrency = (amount: number, targetCurrency = 'USD') => {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: targetCurrency,
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const convertCurrency = (amountUSD: number, toCurrency: string): number => {
    const rate = exchangeRates[toCurrency] ?? exchangeRates['USD'];
    return amountUSD * rate;
  };

  if (ipdata) {
    const currencyCode = ipdata.currency || 'USD';
    const numericAmount = typeof usdAmount === 'bigint' ? Number(usdAmount) : usdAmount;
    const converted = convertCurrency(numericAmount, currencyCode);
    price = formatCurrency(converted, exchangeRates[currencyCode] ? currencyCode : 'USD');
  } else {
    const numericAmount = typeof usdAmount === 'bigint' ? Number(usdAmount) : usdAmount;
    price = formatCurrency(numericAmount, 'USD');
  }

  return price;
};
